import { Box, BoxProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    }
  },
}));


export type InfoRowProps = {
  label: React.ReactNode;
} & BoxProps;


export const InfoRow: React.FC<InfoRowProps> = ({ label, children, ...props }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} {...props}>
      <Box width="64px">
        <Typography color="textSecondary">{label}</Typography>
      </Box>
      <Box>
        {children}
      </Box>
    </Box>
  );
};
